import { BaseActions } from '../base/BaseActions';
import { HierarchyActionTypes } from './HierarchyActionTypes';

export class HierarchyActions extends BaseActions {

    collapseAll() {
        this.dispatch({
            type: HierarchyActionTypes.CollapseAll
        });
    }

    filterHierarchy(term: string) {
        this.dispatch({
            type: HierarchyActionTypes.HierarchySearch,
            data: term
        });
    }

    selectWell(itemId: string) {
        this.dispatch({
            type: HierarchyActionTypes.SelectWell,
            data: itemId
        });
    }

    selectWells(itemIds: string[]) {
        this.dispatch({
            type: HierarchyActionTypes.SelectWells,
            data: itemIds
        });
    }

    unselectWell(itemId: string) {
        this.dispatch({
            type: HierarchyActionTypes.UnselectWell,
            data: itemId
        });
    }

    unselectWells(itemIds?: string[]): Promise<void> {
        return new Promise<void>(resolve => {

            this.dispatch({
                type: HierarchyActionTypes.UnselectWells,
                data: itemIds
            }, () => resolve());

        });
    }
}

export default new HierarchyActions();